export const fixedColumnsTableSettings = { scroll: { x: 2200, y: 'calc(100vh - 260px)' } }
